export const myProduct = []

export const cartItem = []